import apiClient from "@/api/axiosClient";
import type { AuthResponse } from "@/api/auth";

export type AccountSetup = "CreateOnly" | "CreateAndInvite";

export interface TeamMember {
  id: string;
  email?: string;
  displayName?: string;
  role?: string;
  isPending: boolean;
  hasBeenInvited: boolean;
}

export interface InviteTeammatePayload {
  email: string;
  displayName?: string;
  role?: string;
  accountSetup: AccountSetup;
}

export interface InviteResponse {
  email: string;
  token?: string | null;
  invitationSent: boolean;
  warning?: string | null;
}

export interface AcceptInvitePayload {
  email: string;
  token: string;
  password: string;
}

export async function fetchTeam(): Promise<TeamMember[]> {
  const { data } = await apiClient.get<TeamMember[]>("/team");
  return data;
}

export async function inviteTeammate(payload: InviteTeammatePayload): Promise<InviteResponse> {
  const { data } = await apiClient.post<InviteResponse>("/team/invite", payload);
  return data;
}

/// Sends (or resends) the invite for an already-created teammate - the same
/// call handles both, since the backend derives which one it is.
export async function sendTeamInvite(id: string): Promise<InviteResponse> {
  const { data } = await apiClient.post<InviteResponse>(`/team/${id}/send-invite`);
  return data;
}

export async function acceptInvite(payload: AcceptInvitePayload): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>("/team/accept-invite", payload);
  return data;
}
